// extracted by mini-css-extract-plugin
export default {"outer-ring":"style_outer-ring__n1LkJ","pulse-glow":"style_pulse-glow__Jaz6X","inner-ring":"style_inner-ring__9Z6Z0"};